var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveApplications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.5V2.5H8.5V4.5H12.5ZM2.5 6.5V17.5H18.5V6.5H2.5ZM18.5 4.5C19.61 4.5 20.5 5.39 20.5 6.5V17.5C20.5 18.61 19.61 19.5 18.5 19.5H2.5C1.39 19.5 0.5 18.61 0.5 17.5L0.51 6.5C0.51 5.39 1.39 4.5 2.5 4.5H6.5V2.5C6.5 1.39 7.39 0.5 8.5 0.5H12.5C13.61 0.5 14.5 1.39 14.5 2.5V4.5H18.5Z",
    fill: "#F7F7F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveApplications);
export default __webpack_public_path__ + "static/media/active_applications.dc39e9d0fd714ed6f8e89be319f34091.svg";
export { ForwardRef as ReactComponent };